const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

export const getExpirationDate = () => {
  const expireDate = new Date();
  expireDate.setTime(expireDate.getTime() + ONE_YEAR);
  return expireDate;
};
